(function () {
  'use strict';

  let installed = false;
  let pending = null;
  let revision = 0;
  let scheduled = false;

  function install() {
    if (installed || !window.theme || !window.theme.cart ||
        typeof window.theme.cart.getCartProductMarkup !== 'function') return;

    installed = true;
    const cart = window.theme.cart;
    const original = cart.getCartProductMarkup.bind(cart);

    async function refresh(attempt) {
      const startedAt = revision;
      const controller = new AbortController();
      const timeout = window.setTimeout(() => controller.abort(), 8000);
      try {
        const root = window.Shopify && window.Shopify.routes
          ? window.Shopify.routes.root : '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: {} }),
          signal: controller.signal
        });
        if (!response.ok) throw new Error('Cart refresh failed');
        await response.json();
      } catch (error) {
        window.console.warn('PAVELS cart refresh unavailable; loading current cart.');
      } finally {
        window.clearTimeout(timeout);
      }

      const markup = await original();
      if (startedAt !== revision && attempt < 2) return refresh(attempt + 1);
      return markup;
    }

    cart.getCartProductMarkup = function () {
      if (!pending) {
        pending = refresh(0).finally(() => { pending = null; });
      }
      return pending;
    };
  }

  function rebuild(force) {
    install();
    const visibleCart = document.getElementById('CartPageForm') ||
      document.querySelector('#CartDrawer.drawer--is-open');
    if (!installed || (!visibleCart && force !== true) || scheduled) return;
    scheduled = true;
    window.setTimeout(() => {
      scheduled = false;
      document.dispatchEvent(new CustomEvent('cart:build'));
    }, 0);
  }

  document.addEventListener('cart:updated', () => { revision += 1; });
  document.addEventListener('ajaxProduct:added', () => { revision += 1; });
  document.addEventListener('page:loaded', rebuild);
  document.addEventListener('drawerOpen.CartDrawer', () => rebuild(true));
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') rebuild();
  });
  window.addEventListener('focus', rebuild);
  window.addEventListener('pageshow', event => {
    if (event.persisted) rebuild();
  });

  install();
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', rebuild, { once: true });
  } else {
    rebuild();
  }
})();
